module.exports = __webpack_public_path__ + "assets/icons8-search.4fe2adea.svg";